import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const Checkout = loadable(() => import('./Checkout'));

Checkout.getInitialState = getInitialState;

export default Checkout;
